import type { AttributionEvidenceType } from "@redotech/redo-attribution-common/attribution-settings";
import { Flex } from "@redotech/redo-web/flex";
import { memo } from "react";
import { BotFilter } from "../filters/marketing-bot-filter";
import { ChannelFilter } from "../filters/marketing-channel-filter";
import { MarketingAnalyticsAutomationPerformance } from "./marketing-analytics-automation-performance";
import { MarketingAnalyticsCampaignPerformance } from "./marketing-analytics-campaign-performance";
import { MarketingAnalyticsKeyRevenueMetrics } from "./marketing-analytics-key-revenue-metrics";
import { MarketingAnalyticsMessagePerformance } from "./marketing-analytics-message-performance";
import { MarketingAnalyticsSentimentTopics } from "./marketing-analytics-sentiment-topics";

export const MarketingAnalyticsOverview = memo(
  function MarketingAnalyticsOverview({
    dateFilter,
    attributionDays,
    attributionEvidence,
    channelFilter,
    botFilter,
  }: {
    dateFilter: [Temporal.PlainDate, Temporal.PlainDate] | undefined;
    attributionDays: number | undefined;
    attributionEvidence: AttributionEvidenceType[];
    channelFilter: ChannelFilter;
    botFilter: BotFilter;
  }) {
    return (
      <Flex dir="column" gap="4xl" pb="8xl" w="full">
        <MarketingAnalyticsKeyRevenueMetrics
          attributionDays={attributionDays}
          attributionEvidence={attributionEvidence}
          channelFilter={channelFilter}
          dateFilter={dateFilter}
        />
        <MarketingAnalyticsCampaignPerformance
          attributionDays={attributionDays}
          attributionEvidence={attributionEvidence}
          botFilter={botFilter}
          channelFilter={channelFilter}
          dateFilter={dateFilter}
        />
        <MarketingAnalyticsAutomationPerformance
          attributionDays={attributionDays}
          attributionEvidence={attributionEvidence}
          botFilter={botFilter}
          channelFilter={channelFilter}
          dateFilter={dateFilter}
        />
        <MarketingAnalyticsMessagePerformance
          attributionDays={attributionDays}
          attributionEvidence={attributionEvidence}
          botFilter={botFilter}
          channelFilter={channelFilter}
          dateFilter={dateFilter}
        />
        <MarketingAnalyticsSentimentTopics dateFilter={dateFilter} />
      </Flex>
    );
  },
);
